export default {
  EmptyState: {
    title: 'Dodaj pierwszą restaurację',
    description: 'Nie masz jeszcze żadnych restauracji. Utwórz jedną, aby zacząć konfigurację i przyjmować zamówienia.',
    cta: 'Nowa restauracja',
  },
};
